import React from 'react';

const GradientCheck = () => {
	return (
		<svg
			width="24"
			height="23"
			viewBox="0 0 24 23"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<ellipse
				cx="11.9146"
				cy="11.7659"
				rx="11.1702"
				ry="11.1702"
				fill="url(#icon-gradient)"
			/>
			<path
				d="M16.0523 8.66309L10.3638 14.3516L7.77808 11.7659"
				stroke="currentColor"
				strokeWidth="2.48936"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default GradientCheck;
